<template>
    <div id="itemDept">

        <b-row>
            <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                <div class="itemMain">
                    <div class="itemSubTitle">{{$t('i_Departements')}}</div>
                    <div class="itemContain">
                        <s-comboSelector 
                            class="txtPrincipal" 
                            showField="description1" 
                            returnField="id" 
                            :content="deptList" 
                            name= "departements" 
                            :title="$t('i_Departements')" 
                            :value="_DeptId" 
                            :returnValue.sync="_DeptId" 
                            :selectedItems="_DeptId" 
                            :selectStatus="true">
                        </s-comboSelector>
                    </div>
                </div>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemDept',
    components: {

    },
    props: ['leftSize', 'departmentId'],
    data() {
        return {
            collaps: false,
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme']),
        _DeptId: {
            get: function() {return this.departmentId},
            set: function(modifiedValue){this.$emit('update:departmentId', modifiedValue)}
        },
        /**
         * Retourne la liste des départements
         */
         deptList() {
            return this.$store.getters.getInventory.data.departmentList;
        },
    }
}
</script>

<style lang="scss" scoped>

</style>